import Reveal from "@/components/site/Reveal";

const FACCIO_IO = [
  { t: "Prezzi, ogni giorno", d: "Li guardo e li muovo seguendo la domanda, non l'abitudine." },
  { t: "Coerenza ovunque", d: "Stesso prezzo su Booking, Airbnb, gli altri portali e il tuo sito: mai differenze a caso." },
  { t: "Occupazione e prezzo medio", d: "Li tengo sotto controllo ogni settimana: sono loro a dirmi se la strategia funziona." },
  { t: "Vendite e offerte", d: "Promozioni giuste nei momenti giusti, per massimizzare senza svendere." },
  { t: "Prezzo netto per l'ospite", d: "Controllo quanto paga davvero chi prenota, commissioni incluse: niente sorprese che costano recensioni." },
  { t: "Annunci che vendono", d: "Testi, foto e impostazioni curati su ogni portale." },
];

const RESTA_A_TE = [
  { t: "Pulizie e biancheria", d: "La cura fisica della casa resta in mano tua." },
  { t: "Check-in e accoglienza", d: "Gli ospiti li accogli tu, come piace a te." },
  { t: "La casa", d: "Resta tua, come è ovvio. Account e recensioni compresi." },
];

export default function CosaFaccio() {
  return (
    <section id="cosa-faccio" data-testid="cosa-faccio-section" className="border-b border-[#2A241F] py-12 sm:py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <p className="section-kicker">Cosa faccio io, cosa resta a te</p>
          <div className="mt-10 grid gap-4 lg:grid-cols-[3fr_2fr]">
            <div data-testid="cosa-faccio-io" className="border border-[#4D2C20] bg-[#1A1714] p-7 sm:p-9">
              <h3 className="font-heading text-xl font-black uppercase tracking-tight text-[#E05A2C] sm:text-2xl">
                Ci penso io
              </h3>
              <div className="mt-6 grid gap-x-8 sm:grid-cols-2">
                {FACCIO_IO.map((item, i) => (
                  <div key={item.t} className={`${i >= 4 ? "hidden sm:block" : ""} border-t border-[#2A241F] py-4`}>
                    <p className="flex items-baseline gap-3 text-sm font-medium text-[#FAF7F2] sm:text-base">
                      <span className="shrink-0 font-heading font-black text-[#E05A2C]">—</span>
                      {item.t}
                    </p>
                    <p className="mt-1.5 pl-6 text-sm font-light leading-relaxed text-[#A89F91]">{item.d}</p>
                  </div>
                ))}
              </div>
            </div>
            <div data-testid="cosa-faccio-te" className="border border-[#2A241F] p-7 sm:p-9">
              <h3 className="font-heading text-xl font-black uppercase tracking-tight text-[#FAF7F2] sm:text-2xl">
                Resta a te
              </h3>
              <div className="mt-6">
                {RESTA_A_TE.map((item, i) => (
                  <div key={item.t} className={`${i >= 2 ? "hidden sm:block" : ""} border-t border-[#2A241F] py-4`}>
                    <p className="flex items-baseline gap-3 text-sm font-medium text-[#C4BBB0] sm:text-base">
                      <span className="shrink-0 font-heading font-black text-[#A89F91]">—</span>
                      {item.t}
                    </p>
                    <p className="mt-1.5 pl-6 text-sm font-light leading-relaxed text-[#A89F91]">{item.d}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <p className="mt-8 max-w-2xl text-sm font-light leading-relaxed text-[#A89F91] sm:text-base">
            Niente scatole nere: con l'app inclusa vedi ogni mia mossa, ogni giorno.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
